import React, { Suspense, lazy } from 'react';
import { IProject } from '../../../interface/interfaces';
import { substringWords } from '../../../utils/substringWords';
import { Spacing } from '../../layout/Spacing/Spacing';
import { Checker } from '../../shared/Checker/Checker';
import { Loader } from '../../shared/Loader/Loader';
import { TextCustom } from '../../ui/TextCustom';
import { Title } from '../../ui/Title';
import { appDispatch } from '../../../redux/store';
import { saveProject } from './project.slice';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import { ProtectedUsers } from '../../shared/ProtectedUsers/ProtectedUsers';
import { PROJECT_ADMIN, ROUTES } from '../../../constants/constants';
import { useNavigate } from 'react-router';
import { capitalizeString } from '../../../utils/capitalizeString';
import { Badge } from '../../shared/Badge/Badge';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';

interface IProjectNodeProps {
    idx: number;
    project: IProject;
    projectId: string | null;
    dispatch: appDispatch;
}

const IconLoader = lazy(() => import('../IconLoader/IconLoader'));
const MemoizedIconLoader = React.memo(IconLoader);

export const ProjectNode: React.FC<IProjectNodeProps> = ({ idx, project, projectId, dispatch }) => {
    const navigate = useNavigate();
    const isProjectOnline = project.State.toLowerCase() === 'online';
    return (

            <li key={idx} className="projects__item">
                <button className={`projects__button projects__button--${project.State.toLowerCase()}`} onClick={() => dispatch(saveProject(project))} disabled={!isProjectOnline}>
                    <div className="projects__number">{idx + 1}.</div>
                    <div className="projects__rest">
                        <div className="projects__grp">
                            <Suspense
                                fallback={
                                    <Spacing marginSpacing={'none'} paddingSpacing={'s'}>
                                        <Loader color="grey-dark" height={15} width={15} />
                                    </Spacing>
                                }
                            >
                                {/* <MemoizedIconLoader iconName={'Project'} iconSize={3} /> */}
                            </Suspense>
                            <FlexCenter direction="v" position="start" gap={1.5}>
                                <Badge radius='s' fontSize={1} color={`${isProjectOnline ? 'accent-green' : 'error'}`} label={capitalizeString(project.State.toLowerCase())} />
                                <FlexCenter direction="h" position="start" gap={0.5}>
                                    <Title color={`${isProjectOnline ? 'dark' : 'grey-normal'}`} text={substringWords(`${project.name}`, 158)} size="m" />
                                    <TextCustom color={`${isProjectOnline ? 'grey-dark' : 'grey-normal'}`} size={1.2}>
                                        {substringWords(`${project.customer}`, 60)}
                                    </TextCustom>
                                </FlexCenter>
                            </FlexCenter>
                        </div>
                        {project._id === projectId && <Checker />}
                    </div>
                </button>

            </li>
    );
};
